var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMessage24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-bubbles-with-ellipsis",
    transform: "translate(0 -3.24)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46083",
    "data-name": "Path 46083",
    d: "M20.36,9.67h-.493V14.6a1.469,1.469,0,0,1-1.476,1.609H8.743v.758a1.739,1.739,0,0,0,1.72,1.5h7.377l2.822,1.662-.409-1.662h.108a1.333,1.333,0,0,0,1.264-1.5V10.959A1.162,1.162,0,0,0,20.36,9.67Z",
    transform: "translate(-3.624 -.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46084",
    "data-name": "Path 46084",
    d: "M13.327,3.24H1.884A1.924,1.924,0,0,0,0,4.963v7.7c0,.779.961,1.341,1.884,1.428l-.6,2.282,3.846-2.266h8.2c.986,0,1.9-.6,1.9-1.444v-7.7A1.8,1.8,0,0,0,13.327,3.24ZM3.769,9.7A1.014,1.014,0,1,1,4.781,8.689,1.013,1.013,0,0,1,3.769,9.7Zm3.781,0A1.014,1.014,0,1,1,8.562,8.689,1.013,1.013,0,0,1,7.55,9.7Zm3.782,0a1.014,1.014,0,1,1,1.012-1.014A1.014,1.014,0,0,1,11.331,9.7Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMessage24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_message24x24.451105763bc457f5254fc844abcf89ee.svg";